<script setup lang="ts">
import { Modal, notification } from 'ant-design-vue';

import FileAiPromptForm, { type FileAiPromptFormValues } from './FileAiPromptForm.vue';

import type { FileAiPromptFragmentFragment } from '@/graphql/generated/graphql';
import { useFileAiPromptUpdateMutation } from '@/graphql/generated/graphql';

defineProps<{
  open: boolean;
  record: FileAiPromptFragmentFragment;
}>();

const emit = defineEmits<{
  'update:open': [value: boolean];
}>();

const { fetching, error, executeMutation } = useFileAiPromptUpdateMutation();


const setOpen = (value: boolean) => {
  emit('update:open', value);
};

const onFormSubmit = async (id: number, input: FileAiPromptFormValues) => {
  const response = await executeMutation({
    id: id,
    input,
  });
  if (response.data?.fileAiPromptUpdate) {
    notification.success({ message: 'File AI Prompt updated' });
    setOpen(false);
  }
};

const onCancel = () => {
  setOpen(false);
};
</script>

<template>
  <Modal
    title="Edit File AI Prompt"
    :open="open"
    :confirm-loading="fetching"
    :footer="false"
    width="720px"
    destroy-on-close
    @cancel="onCancel"
  >
    <FileAiPromptForm
      v-if="open"
      :key="record.id"
      :initial-values="record"
      :fetching="fetching"
      :error="error"
      submit-label="Update"
      @submit="(values) => onFormSubmit(record.id, values)"
      @cancel="onCancel"
    />
  </Modal>
</template>
